import { parseISO, isValid } from 'date-fns';

export const toTimestamp = (dateInput) => {
  const d = typeof dateInput === 'string' ? parseISO(dateInput) : dateInput;
  return isValid(d) ? d.getTime() : null;
};

export const CHART_MARGIN = { top: 10, right: 45, left: 10, bottom: 10 };
